module.exports = __webpack_public_path__ + "static/media/drake_img_2.ec48efe0.png";